// What a seller's answer costs the customer and earns the seller. The gateway
// owns the rule (domain.SellerChargeTable in server/internal/domain/
// seller_charge.go); this is its wording for sellers, used by the endpoint
// contract on the dashboard and by the seller onboarding skill.

/** Answers the customer is charged for; the seller is paid 80% of the charge. */
export const SELLER_CHARGED_ANSWERS = [
  'A real result',
  'found: false because the thing does not exist',
  'found: false because the account is suspended, private or unavailable',
  'A search with zero results',
] as const;

/** Answers that are free to the customer and unpaid; the next source is tried. */
export const SELLER_FREE_ANSWERS = [
  'A bot wall or block page',
  'found: true with every required field empty',
  'An error (any non-2xx status)',
  'A timeout',
  'A rate limit (429)',
  'A malformed reply (not JSON, or not matching the schema)',
] as const;

/** How a seller reports an answer it could not get. */
export const SELLER_FAILURE_HOWTO =
  'If the site blocked you, rate limited you or anything else went wrong, answer with a non-2xx status (429 for a rate limit). Never answer found: false or an empty result for a call you could not make.';
